export const EMERALD_LIGHT = '#0CCF7C';
export const EMERALD_DEFAULT = '#007358';
export const EMERALD_DARK = '#025441';
export const LIGHT_GRAY_INPUT = '#F5F5F5';
export const LIGHT_GRAY_BORDER = '#E2E8F0';
export const DEFAULT_HEX_COLOR = '#000000';

export const STATUS_INFO = '#0EA5E9';
export const STATUS_SUCCESS = '#10B981';
export const STATUS_WARNING = '#F59E0B';
export const STATUS_DANGER = '#EF4444';

export const FYI_COLOR = '#9CA3AF';

export const SEMANTIC_BG_INPUT = 'var(--color-bg-input)';
export const SEMANTIC_BORDER_INPUT = 'var(--color-border-input)';
export const SEMANTIC_BG_HOVER = 'var(--color-bg-hover)';
export const SEMANTIC_TEXT_SECONDARY = 'var(--color-text-secondary)';
export const SEMANTIC_BG_ACCENT = 'var(--color-bg-accent)';
export const SEMANTIC_BG_SURFACE = 'var(--color-bg-surface)';
export const COLOR_WHITE = 'var(--color-neutral-100)';
